import { axios } from '@/lib/axios';

export const getCryptoWallets = async () => {
  const response = await axios.get('/crypto/config/company-wallet-addresses');
  return response.data;
};
